import mainNav from "../navigation/mainNav";
import router from "../router";
import EnumRole from "../router/roleList";

export function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = array => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

export const userTabs = tabs => {
  let userAccess = {
    GENERAL: false,
    TECH_STAT: false,
    SALES: false,
    ISSUES: false,
    FNS: false,
    ACC_REC: false
  };
  if (tabs && tabs.length > 0)
    Object.keys(userAccess).map(key => {
      if (tabs.includes(EnumRole[key])) {
        userAccess[key] = true;
      }
    });
  return userAccess;
};

export const allowedPath = (currentPath, tabs, replacePath) => {
  let formatedCurrentPath =
    currentPath.slice(-1) === "/" ? currentPath.slice(0, -1) : currentPath;
  let matchingPath = false;
  let at = userTabs(JSON.parse(tabs));
  let childrenArray = [];
  let redirectPath = "";
  if (localStorage.getItem("fns_user")) {
    for (const [key, value] of Object.entries(at)) {
      if (value) {
        if (redirectPath.length === 0) {
          redirectPath = mainNav[key].route.mainRoute;
        }
        childrenArray.push(...mainNav[key].route.children);
      }
    }
  }

  childrenArray.map(childrenPath => {
    if ("/" + childrenPath.path === formatedCurrentPath) {
      matchingPath = true;
      return;
    }
  });
  if (!matchingPath) router.replace({ path: replacePath });
};
